import AiDots from '@/components/view/atoms/loading/AiDots'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

const animationStyle = `
@keyframes ai-loading-orbit {
  0% { transform: translateX(7px) translateY(6.5px) translate(33px, 33.5px) rotate(0rad) translate(-33px, -33.5px); }
  100% { transform: translateX(7px) translateY(6.5px) translate(33px, 33.5px) rotate(5.8rad) translate(-33px, -33.5px); }
}
.ai-loading #ai-loading-orbit {
  transform-origin: 0 0;
  animation: ai-loading-orbit 4.8s linear infinite;
}
@keyframes ai-loading-doc {
  0% {
    animation-timing-function: ease-in-out;
    transform: translateX(19px) translateY(15px) translateX(0px) translateY(1px) translate(21px, 25px) scaleX(0.96) scaleY(0.96) translate(-21px, -25px);
  }
  27.08% {
    animation-timing-function: ease-in-out;
    transform: translateX(19px) translateY(15px) translateX(0px) translateY(-1px) translate(21px, 25px) scaleX(1) scaleY(1) translate(-21px, -25px);
  }
  54.17% {
    transform: translateX(19px) translateY(15px) translateX(0px) translateY(1px) translate(21px, 25px) scaleX(0.96) scaleY(0.96) translate(-21px, -25px);
  }
  100% {
    transform: translateX(19px) translateY(15px) translateX(0px) translateY(1px) translate(21px, 25px) scaleX(0.96) scaleY(0.96) translate(-21px, -25px);
  }
}
.ai-loading #ai-loading-doc {
  transform-origin: 0 0;
  animation: ai-loading-doc 4.8s linear infinite;
}
@keyframes ai-loading-line-1-opacity {
  0% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: -0.1; }
  6.5% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 0; }
  22.75% { animation-timing-function: linear; opacity: 1; }
  33.33% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 1; }
  43.33% { animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1); opacity: -0.1; }
  54.17% { animation-timing-function: linear; opacity: 0; }
  100% { opacity: 0; }
}
@keyframes ai-loading-line-1-trim {
  0% { stroke-dasharray: 0 1; visibility: hidden; }
  6.5% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); stroke-dasharray: 0 1; visibility: hidden; }
  22.75% { stroke-dasharray: 1 1; visibility: visible; }
  33.377% { stroke-dasharray: 1 1; visibility: visible; }
  43.333% { stroke-dasharray: 1 1; visibility: visible; }
  54.167% { stroke-dasharray: 1 1; visibility: visible; }
  100% { stroke-dasharray: 1 1; visibility: visible; }
}
.ai-loading #ai-loading-line-1 {
  stroke-dashoffset: 0;
  animation:
    ai-loading-line-1-opacity 4.8s linear infinite,
    ai-loading-line-1-trim 4.8s linear infinite;
}
@keyframes ai-loading-line-2-opacity {
  0% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: -0.1; }
  8.33% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 0.2; }
  22.75% { animation-timing-function: linear; opacity: 1; }
  33.33% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 1; }
  43.8% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 0; }
  54.17% { animation-timing-function: linear; opacity: -0.1; }
  100% { opacity: -0.1; }
}
@keyframes ai-loading-line-2-trim {
  0% { stroke-dasharray: 0 1; visibility: hidden; }
  8.333% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); stroke-dasharray: 0 1; visibility: hidden; }
  22.75% { stroke-dasharray: 1 1; visibility: visible; }
  33.35% { stroke-dasharray: 1 1; visibility: visible; }
  43.802% { stroke-dasharray: 1 1; visibility: visible; }
  54.167% { stroke-dasharray: 1 1; visibility: visible; }
  100% { stroke-dasharray: 1 1; visibility: visible; }
}
.ai-loading #ai-loading-line-2 {
  stroke-dashoffset: 0;
  animation:
    ai-loading-line-2-opacity 4.8s linear infinite,
    ai-loading-line-2-trim 4.8s linear infinite;
}
@keyframes ai-loading-line-3-opacity {
  0% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: -0.1; }
  10% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 0.2; }
  22.75% { animation-timing-function: linear; opacity: 1; }
  33.33% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 1; }
  48.33% { animation-timing-function: linear; opacity: -0.1; }
  54.17% { animation-timing-function: linear; opacity: -0.1; }
  100% { opacity: -0.1; }
}
@keyframes ai-loading-line-3-trim {
  0% { stroke-dasharray: 0 1; visibility: hidden; }
  10% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); stroke-dasharray: 0 1; visibility: hidden; }
  22.75% { stroke-dasharray: 1 1; visibility: visible; }
  33.36% { stroke-dasharray: 1 1; visibility: visible; }
  48.333% { stroke-dasharray: 1 1; visibility: visible; }
  54.167% { stroke-dasharray: 1 1; visibility: visible; }
  100% { stroke-dasharray: 1 1; visibility: visible; }
}
.ai-loading #ai-loading-line-3 {
  stroke-dashoffset: 0;
  animation:
    ai-loading-line-3-opacity 4.8s linear infinite,
    ai-loading-line-3-trim 4.8s linear infinite;
}
@keyframes ai-loading-line-4-opacity {
  0% { animation-timing-function: linear; opacity: -0.1; }
  0.35% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: -0.1; }
  11.67% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 0.2; }
  22.95% { animation-timing-function: linear; opacity: 1; }
  33.33% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); opacity: 1; }
  51.67% { animation-timing-function: linear; opacity: -0.1; }
  54.17% { animation-timing-function: linear; opacity: -0.1; }
  100% { opacity: -0.1; }
}
@keyframes ai-loading-line-4-trim {
  0% { stroke-dasharray: 0 1; visibility: hidden; }
  0.15% { stroke-dasharray: 0 1; visibility: hidden; }
  0.351% { stroke-dasharray: 0 1; visibility: hidden; }
  11.667% { animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1); stroke-dasharray: 0 1; visibility: hidden; }
  22.954% { stroke-dasharray: 1 1; visibility: visible; }
  33.333% { stroke-dasharray: 1 1; visibility: visible; }
  51.667% { stroke-dasharray: 1 1; visibility: visible; }
  54.167% { stroke-dasharray: 1 1; visibility: visible; }
  100% { stroke-dasharray: 1 1; visibility: visible; }
}
.ai-loading #ai-loading-line-4 {
  stroke-dashoffset: 0;
  animation:
    ai-loading-line-4-opacity 4.8s linear infinite,
    ai-loading-line-4-trim 4.8s linear infinite;
}
@keyframes ai-loading-dot-transform {
  0% {
    animation-timing-function: ease-in-out;
    transform: translateX(27.8px) translateY(40.8px) translate(2.2px, 2.2px) scaleX(0.65) scaleY(0.65) translate(-2.2px, -2.2px);
  }
  13.54% {
    animation-timing-function: ease-in-out;
    transform: translateX(27.8px) translateY(40.8px) translate(2.2px, 2.2px) scaleX(1.25) scaleY(1.25) translate(-2.2px, -2.2px);
  }
  27.08% {
    transform: translateX(27.8px) translateY(40.8px) translate(2.2px, 2.2px) scaleX(0.65) scaleY(0.65) translate(-2.2px, -2.2px);
  }
  100% {
    transform: translateX(27.8px) translateY(40.8px) translate(2.2px, 2.2px) scaleX(0.65) scaleY(0.65) translate(-2.2px, -2.2px);
  }
}
@keyframes ai-loading-dot-opacity {
  0% { animation-timing-function: ease-in-out; opacity: 0.35; }
  13.54% { animation-timing-function: ease-in-out; opacity: 1; }
  27.08% { animation-timing-function: linear; opacity: 0.35; }
  100% { opacity: 0.35; }
}
.ai-loading #ai-loading-dot {
  transform-origin: 0 0;
  animation:
    ai-loading-dot-transform 4.8s linear infinite,
    ai-loading-dot-opacity 4.8s linear infinite;
}
@keyframes ai-loading-sparkle-1-transform {
  0% { transform: translateX(58px) translateY(14px) translate(6px, 6px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-6px, -6px); }
  9.73% {
    animation-timing-function: ease-in-out;
    transform: translateX(58px) translateY(14px) translate(6px, 6px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-6px, -6px);
  }
  33.38% {
    animation-timing-function: ease-in-out;
    transform: translateX(58px) translateY(14px) translate(6px, 6px) rotate(3.142rad) scaleX(1.12) scaleY(1.12) translate(-6px, -6px);
  }
  40.27% {
    animation-timing-function: ease-in-out;
    transform: translateX(58px) translateY(14px) translate(6px, 6px) rotate(3.665rad) scaleX(0.9) scaleY(0.9) translate(-6px, -6px);
  }
  59% { transform: translateX(58px) translateY(14px) translate(6px, 6px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-6px, -6px); }
  100% { transform: translateX(58px) translateY(14px) translate(6px, 6px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-6px, -6px); }
}
@keyframes ai-loading-sparkle-1-opacity {
  0% { animation-timing-function: linear; opacity: 0.15; }
  9.73% { animation-timing-function: ease-in-out; opacity: 0.15; }
  33.38% { animation-timing-function: ease-in-out; opacity: 1; }
  40.27% { animation-timing-function: ease-in-out; opacity: 0.8; }
  59% { animation-timing-function: linear; opacity: 0.15; }
  100% { opacity: 0.15; }
}
.ai-loading #ai-loading-sparkle-1 {
  transform-origin: 0 0;
  animation:
    ai-loading-sparkle-1-transform 4.8s linear infinite,
    ai-loading-sparkle-1-opacity 4.8s linear infinite;
}
@keyframes ai-loading-sparkle-2-transform {
  0% { transform: translateX(11px) translateY(52px) translate(4px, 4px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4px, -4px); }
  18.75% {
    animation-timing-function: ease-in-out;
    transform: translateX(11px) translateY(52px) translate(4px, 4px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4px, -4px);
  }
  40.27% {
    animation-timing-function: ease-in-out;
    transform: translateX(11px) translateY(52px) translate(4px, 4px) rotate(3.142rad) scaleX(1.12) scaleY(1.12) translate(-4px, -4px);
  }
  46.55% {
    animation-timing-function: ease-in-out;
    transform: translateX(11px) translateY(52px) translate(4px, 4px) rotate(3.665rad) scaleX(0.9) scaleY(0.9) translate(-4px, -4px);
  }
  63.58% { transform: translateX(11px) translateY(52px) translate(4px, 4px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4px, -4px); }
  100% { transform: translateX(11px) translateY(52px) translate(4px, 4px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4px, -4px); }
}
@keyframes ai-loading-sparkle-2-opacity {
  0% { animation-timing-function: linear; opacity: 0.15; }
  18.75% { animation-timing-function: ease-in-out; opacity: 0.15; }
  40.27% { animation-timing-function: ease-in-out; opacity: 1; }
  46.55% { animation-timing-function: ease-in-out; opacity: 0.8; }
  63.58% { animation-timing-function: linear; opacity: 0.15; }
  100% { opacity: 0.15; }
}
.ai-loading #ai-loading-sparkle-2 {
  transform-origin: 0 0;
  animation:
    ai-loading-sparkle-2-transform 4.8s linear infinite,
    ai-loading-sparkle-2-opacity 4.8s linear infinite;
}
@keyframes ai-loading-sparkle-3-transform {
  0% {
    animation-timing-function: ease-in-out;
    transform: translateX(11.5px) translateY(18px) translate(4.5px, 4.5px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4.5px, -4.5px);
  }
  26% {
    animation-timing-function: ease-in-out;
    transform: translateX(11.5px) translateY(18px) translate(4.5px, 4.5px) rotate(3.142rad) scaleX(1.12) scaleY(1.12) translate(-4.5px, -4.5px);
  }
  33.58% {
    animation-timing-function: ease-in-out;
    transform: translateX(11.5px) translateY(18px) translate(4.5px, 4.5px) rotate(3.665rad) scaleX(0.9) scaleY(0.9) translate(-4.5px, -4.5px);
  }
  54.17% {
    transform: translateX(11.5px) translateY(18px) translate(4.5px, 4.5px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4.5px, -4.5px);
  }
  100% {
    transform: translateX(11.5px) translateY(18px) translate(4.5px, 4.5px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4.5px, -4.5px);
  }
}
@keyframes ai-loading-sparkle-3-opacity {
  0% { animation-timing-function: ease-in-out; opacity: 0.15; }
  26% { animation-timing-function: ease-in-out; opacity: 1; }
  33.58% { animation-timing-function: ease-in-out; opacity: 0.8; }
  54.17% { animation-timing-function: linear; opacity: 0.15; }
  100% { opacity: 0.15; }
}
.ai-loading #ai-loading-sparkle-3 {
  transform-origin: 0 0;
  animation:
    ai-loading-sparkle-3-transform 4.8s linear infinite,
    ai-loading-sparkle-3-opacity 4.8s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .ai-loading * {
    animation: none !important;
  }
}
`

interface Props {
  description: string
  prompt?: string
}

const AiLoading = ({ description, prompt = 'プロンプトを読み込み中' }: Props) => {
  return (
    <div
      className='flex flex-col items-center justify-center gap-4'
      role='status'
      aria-live='polite'
    >
      <div className='flex flex-col items-center gap-2'>
        <svg
          className='ai-loading shrink-0'
          width='80'
          height='80'
          viewBox='0 0 80 80'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          aria-hidden='true'
        >
          <style>{animationStyle}</style>
          <g clipPath='url(#ai-loading-clip)'>
            <g id='ai-loading-orbit' opacity='0.72' transform='translate(7 6.5)'>
              <path
                transform='translate(31.5)'
                d='M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z'
                fill='#641BDE'
              />
              <path
                transform='translate(64 32.5)'
                d='M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z'
                fill='#CC00B7'
              />
              <path
                transform='translate(31.5 64)'
                d='M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z'
                fill='#E5004C'
              />
              <path
                transform='translate(0 32.5)'
                d='M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z'
                fill='#CC00B7'
              />
            </g>
            <g id='ai-loading-doc' transform='translate(19 15)'>
              <path
                d='M32 0H10C4.47715 0 0 4.47715 0 10V40C0 45.5228 4.47715 50 10 50H32C37.5228 50 42 45.5228 42 40V10C42 4.47715 37.5228 0 32 0Z'
                fill='url(#ai-loading-paint0)'
                stroke='url(#ai-loading-paint1)'
                strokeWidth='1.5'
              />
              <path
                transform='translate(5.5 5.5)'
                d='M26.5 0H4.5C2.01472 0 0 2.01472 0 4.5C0 6.98528 2.01472 9 4.5 9H26.5C28.9853 9 31 6.98528 31 4.5C31 2.01472 28.9853 0 26.5 0Z'
                fill='url(#ai-loading-paint2)'
              />
              <path
                transform='translate(10 6.5)'
                d='M3.5 0L4.45 2.55L7 3.5L4.45 4.45L3.5 7L2.55 4.45L0 3.5L2.55 2.55L3.5 0Z'
                fill='#641BDE'
              />
              <path
                transform='translate(21 10)'
                d='M0 0H9'
                stroke='#CC00B7'
                strokeWidth='2.2'
                strokeLinecap='round'
              />
              <path
                id='ai-loading-line-1'
                transform='translate(8 22)'
                d='M0 0H26'
                pathLength={1}
                stroke='url(#ai-loading-paint3)'
                strokeWidth='3'
                strokeLinecap='round'
                strokeDasharray='1 1'
              />
              <path
                id='ai-loading-line-2'
                transform='translate(8 29)'
                d='M0 0H21'
                pathLength={1}
                stroke='url(#ai-loading-paint4)'
                strokeWidth='3'
                strokeLinecap='round'
                strokeDasharray='1 1'
              />
              <path
                id='ai-loading-line-3'
                transform='translate(8 36)'
                d='M0 0H26'
                pathLength={1}
                stroke='url(#ai-loading-paint5)'
                strokeWidth='3'
                strokeLinecap='round'
                strokeDasharray='1 1'
              />
              <path
                id='ai-loading-line-4'
                transform='translate(8 43)'
                d='M0 0H16'
                pathLength={1}
                stroke='url(#ai-loading-paint6)'
                strokeWidth='3'
                strokeLinecap='round'
                strokeDasharray='1 1'
              />
              <g
                id='ai-loading-dot'
                filter='url(#ai-loading-blur0)'
                transform='translate(27.8 40.8)'
              >
                <path
                  d='M2.2 4.4C3.41503 4.4 4.4 3.41503 4.4 2.2C4.4 0.984974 3.41503 0 2.2 0C0.984974 0 0 0.984974 0 2.2C0 3.41503 0.984974 4.4 2.2 4.4Z'
                  fill='#E5004C'
                />
              </g>
            </g>
            <g
              id='ai-loading-sparkle-1'
              filter='url(#ai-loading-blur1)'
              transform='translate(58 14)'
            >
              <path d='M6 0L7.5 4.5L12 6L7.5 7.5L6 12L4.5 7.5L0 6L4.5 4.5L6 0Z' fill='#CC00B7' />
            </g>
            <g id='ai-loading-sparkle-2' transform='translate(11 52)'>
              <path d='M4 0L5 3L8 4L5 5L4 8L3 5L0 4L3 3L4 0Z' fill='#E5004C' />
            </g>
            <g id='ai-loading-sparkle-3' transform='translate(11.5 18)'>
              <path
                d='M4.5 0L5.7 3.3L9 4.5L5.7 5.7L4.5 9L3.3 5.7L0 4.5L3.3 3.3L4.5 0Z'
                fill='#641BDE'
              />
            </g>
          </g>
          <defs>
            <filter
              id='ai-loading-blur0'
              x='-4.6'
              y='-4.6'
              width='13.5999'
              height='13.6'
              filterUnits='userSpaceOnUse'
              colorInterpolationFilters='sRGB'
            >
              <feFlood floodOpacity='0' result='BackgroundImageFix' />
              <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
              <feGaussianBlur stdDeviation='2.3' result='effect1_foregroundBlur' />
            </filter>
            <filter
              id='ai-loading-blur1'
              x='-4.6'
              y='-4.6'
              width='21.2'
              height='21.2'
              filterUnits='userSpaceOnUse'
              colorInterpolationFilters='sRGB'
            >
              <feFlood floodOpacity='0' result='BackgroundImageFix' />
              <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
              <feGaussianBlur stdDeviation='2.3' result='effect1_foregroundBlur' />
            </filter>
            <linearGradient
              id='ai-loading-paint0'
              x1='5'
              y1='2'
              x2='38'
              y2='50'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#FCF8FF' />
              <stop offset='0.52' stopColor='#FFF4FC' />
              <stop offset='1' stopColor='#FFF1F4' />
            </linearGradient>
            <linearGradient
              id='ai-loading-paint1'
              x1='1'
              y1='5'
              x2='43'
              y2='47'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#641BDE' />
              <stop offset='0.5' stopColor='#CC00B7' />
              <stop offset='1' stopColor='#E5004C' />
            </linearGradient>
            <linearGradient
              id='ai-loading-paint2'
              x1='-0.5'
              y1='-0.5'
              x2='31.5'
              y2='9.5'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#E9DDFC' />
              <stop offset='0.5' stopColor='#F8DDF4' />
              <stop offset='1' stopColor='#FFDCE6' />
            </linearGradient>
            <linearGradient
              id='ai-loading-paint3'
              x1='-7'
              y1='-17'
              x2='35'
              y2='25'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#641BDE' />
              <stop offset='0.5' stopColor='#CC00B7' />
              <stop offset='1' stopColor='#E5004C' />
            </linearGradient>
            <linearGradient
              id='ai-loading-paint4'
              x1='-7'
              y1='-24'
              x2='35'
              y2='18'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#641BDE' />
              <stop offset='0.5' stopColor='#CC00B7' />
              <stop offset='1' stopColor='#E5004C' />
            </linearGradient>
            <linearGradient
              id='ai-loading-paint5'
              x1='-7'
              y1='-31'
              x2='35'
              y2='11'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#641BDE' />
              <stop offset='0.5' stopColor='#CC00B7' />
              <stop offset='1' stopColor='#E5004C' />
            </linearGradient>
            <linearGradient
              id='ai-loading-paint6'
              x1='-7'
              y1='-38'
              x2='35'
              y2='4'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#641BDE' />
              <stop offset='0.5' stopColor='#CC00B7' />
              <stop offset='1' stopColor='#E5004C' />
            </linearGradient>
            <clipPath id='ai-loading-clip'>
              <rect width='80' height='80' fill='white' />
            </clipPath>
          </defs>
        </svg>
        <div className='flex items-center gap-1'>
          <Text size={16} weight='bold' color={TextColor.AI} nowrap>
            {description}
          </Text>
          <AiDots />
        </div>
      </div>
      <Text size={12} color={TextColor.TERTIARY} align='center'>
        {prompt}
      </Text>
    </div>
  )
}

export default AiLoading
